import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Map of cacheKey -> { data: Array, timestamp: number }
  cache: {}
};

const slice = createSlice({
  name: 'autocompleteCache',
  initialState,
  reducers: {
    setCacheData(state, action) {
      const { key, data } = action.payload;
      state.cache[key] = {
        data,
        timestamp: Date.now()
      };
    },
    invalidateCacheKey(state, action) {
      delete state.cache[action.payload];
    },
    clearAutocompleteCache(state) {
      state.cache = {};
    }
  }
});

export const { setCacheData, invalidateCacheKey, clearAutocompleteCache } =
  slice.actions;

export const reducer = slice.reducer;

export default slice;
